import React, { useCallback } from "react";

import { HubHookFormSelect } from "../HubHookFormSelect";
import { useRolesHookFormList } from "./useRolesHookFormList";

export const HubHookFormRoleSelect = ({
  name = "roleId",
  label = "Role",
  hideLabel = false,
  required = true,
  customFilter,
  locationId,
  includeName,
  ...rest
}) => {
  const { roles = [], isLoading } = useRolesHookFormList({ locationId });

  const filterFunction = useCallback((u) => customFilter(u), [customFilter]);
  const filtered = customFilter ? roles.filter(filterFunction) : roles;

  const defaultProps = {
    ...(!hideLabel ? { label } : {}),
    ...(!locationId && { groupByKey: "location" }),
  };

  return (
    <HubHookFormSelect
      name={name}
      options={filtered}
      labelKey="name"
      required={required}
      disabled={isLoading}
      {...defaultProps}
      {...rest}
    />
  );
};

export default HubHookFormRoleSelect;
